var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconNotifications(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "notifications",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_181",
    "data-name": "Rectangle 181",
    width: 34,
    height: 34,
    transform: "translate(888 137)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_9",
    "data-name": "Mask Group 9",
    transform: "translate(-888 -137)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "FontAwsome_bell_",
    "data-name": "FontAwsome (bell)",
    d: "M23.565,19.43c-1.036-1.113-2.975-2.788-2.975-8.275a8.469,8.469,0,0,0-6.862-8.321V1.716a1.715,1.715,0,1,0-3.43,0V2.834a8.469,8.469,0,0,0-6.862,8.321c0,5.487-1.939,7.161-2.975,8.275A1.676,1.676,0,0,0,0,20.595a1.718,1.718,0,0,0,1.722,1.716H22.305a1.717,1.717,0,0,0,1.722-1.716,1.675,1.675,0,0,0-.462-1.164Zm-19.943.306C4.76,18.236,6,15.75,6.01,11.186c0-.011,0-.02,0-.031a6.007,6.007,0,0,1,12.013,0c0,.011,0,.02,0,.031.006,4.564,1.25,7.05,2.388,8.55Zm8.392,7.723a3.432,3.432,0,0,0,3.431-3.432H8.583A3.432,3.432,0,0,0,12.014,27.459Z",
    transform: "translate(890.227 143.454) rotate(-12)",
    fill: "#b1cb79"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconNotifications);
export default __webpack_public_path__ + "static/media/icon_notifications.d090a53e8b4e04e9537b9c823147ffe2.svg";
export { ForwardRef as ReactComponent };